<div
  class="court-column"
  [attr.data-grid-col]="gridColKey()"
  [style.width.px]="courtColumnWidth()"
  [style.minWidth.px]="courtColumnWidth()"
  [style.height.px]="totalHeightPx()"
  [style.backgroundImage]="gridlineBackground()">

  @for (cell of freeCells(); track cell.startTimeUtc) {
    <div
      class="free-cell"
      [class.out-of-lead-time]="cell.outOfLeadTime"
      [style.top.px]="cell.top"
      [style.height.px]="cell.height"
      role="button"
      tabindex="0"
      [attr.aria-disabled]="cell.outOfLeadTime ? 'true' : null"
      [attr.aria-label]="freeCellAriaLabel(cell)"
      (pointerdown)="onFreeCellPointerDown($event, cell)"
      (click)="onFreeCellActivate(cell)"
      (keydown.enter)="onFreeCellActivate(cell)"
      (keydown.space)="onFreeCellActivate(cell); $event.preventDefault()">
    </div>
  }

  @for (seg of segments(); track seg.startTimeUtc) {
    @let height = segHeight(seg);
    @let tier = segmentTier(height);
    @let clickable = isCourseClickable(seg);
    <div
      class="segment-block"
      [ngClass]="[segmentKindClass(seg), 'tier-' + tier]"
      [class.past]="seg.isPast === true"
      [class.course-clickable]="clickable"
      [style.top.px]="segBlockTop(seg)"
      [style.height.px]="segBlockHeight(height)"
      [title]="segmentTitle(seg)"
      [attr.role]="clickable ? 'button' : null"
      [attr.tabindex]="clickable ? 0 : null"
      [attr.aria-label]="clickable ? courseAriaLabel(seg) : null"
      (click)="onCourseSegmentActivate(seg)"
      (keydown.enter)="onCourseSegmentActivate(seg)"
      (keydown.space)="onCourseSegmentActivate(seg); $event.preventDefault()">
      @if (seg.kind !== 'past') {
        <!-- One shared source for the wording (plan §6.4.3): a plain Kurs shows
             its effective name, an event shows "Turnier – X · Anmelden · 12/16",
             a Platzsperre shows "Gesperrt – X". See court-segment-label.util. -->
        <span class="segment-type">{{ segmentText(seg) }}</span>
        <span class="segment-time" [class.compact]="tier === 'xs'">{{ formatRange(seg.startTimeUtc, seg.endTimeUtc) }}</span>
      }
      @if (seg.isOwn) {
        <!-- "Ecke" own-booking corner badge: filled top-right triangle with a
             white checkmark — the unified "this block is yours" indicator for
             enrolled courses AND the user's own individual/subscription
             bookings (replaces the old round enrolled-badge circle). -->
        <span
          class="own-corner-triangle"
          role="img"
          [title]="ownBadgeLabel(seg)"
          [attr.aria-label]="ownBadgeLabel(seg)"></span>
        <span class="own-corner-check" aria-hidden="true">✓</span>
      }
    </div>
  }
</div>
